import { Button } from "@/components/ui/baseUi/button"
import { Text } from "@/components/ui/baseUi/text"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/baseUi/tooltip"
import { word } from "@modules/core/utils/i18n"
import { ExternalLink, Info } from "lucide-react"

export function CoachBannerCard() {
  return (
    <TooltipProvider>
      <Tooltip>
        <div className="flex items-start gap-4 rounded-2xl bg-surface-background-primary-information-secondary p-5">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-interactive-background-primary-default">
            <Info className="size-5 text-interactive-text-secondary-default" />
          </div>
          <div className="flex flex-1 flex-col gap-3">
            <TooltipTrigger
              render={
                <div className="flex cursor-help flex-col gap-1">
                  <Text fontStyle="TS" className="font-semibold text-textOnSurface-default">
                    {word("coach.admin.banner.title")}
                  </Text>
                  <Text fontStyle="BM" className="text-textOnSurface-subtle">
                    {word("coach.admin.banner.subtitle")}
                  </Text>
                </div>
              }
            />
            <Button
              variant="primary"
              size="sm"
              className="w-fit gap-2"
              render={
                <a href="#" target="_blank" rel="noopener noreferrer">
                  {word("coach.admin.banner.cta")}
                  <ExternalLink className="size-4" />
                </a>
              }
            />
          </div>
        </div>
        <TooltipContent side="bottom" align="center" className="max-w-74 rounded-xl p-0 shadow-lg">
          <div className="p-4">
            <Text fontStyle="BM" className="wrap-break-word whitespace-break-spaces">
              {word("coach.admin.banner.tooltip")}
            </Text>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
